import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { LoaderState } from './loaderReducer';

export const setLoading = (loading: boolean, id?: string) => ({
  type: 'SET_LOADER_STATE',
  id,
  loading
});

export const useLoaderActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    setLoading: (value: boolean, id?: string) => dispatch(setLoading(value, id))
  };
};

export const isLoading = (id?: string) => {
  return useSelector((s: { loader: LoaderState }) => {
    if (id) return s.loader.loaderWithId[id];
    return s.loader.loading;
  });
};
